import { Loading3QuartersOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';

const ImageAwarePopover = ({
  imageDataWorkData,
  isFacebookDomain,
  imageLink,
  uploadImageLink,
  border,
  fetcher,
  errorMessage,
  data
}) => {
  const [onlineSrc, setOnlineSrc] = useState(
    imageDataWorkData.imageData.imageUrl
  );
  const [isLoading, setIsLoading] = useState(false);
  const [hasTriedFallback, setHasTriedFallback] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    setOnlineSrc(imageDataWorkData.imageData.imageUrl);
    setHasTriedFallback(false);
    setLoadFailed(false);
    setIsLoading(false);
  }, [imageDataWorkData.imageData.id, imageDataWorkData.imageData.imageUrl]);

  const handleImageError = () => {
    if (!isFacebookDomain || hasTriedFallback) return;

    setHasTriedFallback(true);
    setIsLoading(true);

    fetcher(imageDataWorkData.imageData.id)
      .then((result) => {
        if (result?.imageUrl) {
          setOnlineSrc(result.imageUrl);
        } else {
          setLoadFailed(true);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch fallback image:', err);
        setLoadFailed(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div
      className='images-table-row'
      style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}
    >
      <div
        className='table-row__image'
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          flexDirection: 'column',
          alignItems: 'center',
          marginRight: 10
        }}
      >
        <a
          target='_blank'
          href={uploadImageLink}
          rel='nofollow noopener noreferrer'
        >
          <span>Uploaded</span>
          <img
            className='popover-image_qc'
            alt=''
            src={uploadImageLink}
            style={{ border: border ? '1px solid beige' : '' }}
          />
        </a>
      </div>

      <div
        className='table-row__image'
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {isLoading && (
          <div
            className='popover-image_qc'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Loading3QuartersOutlined
              style={{
                fontSize: 24,
                animation: 'spin 1s linear infinite'
              }}
            />
          </div>
        )}

        {!isLoading && !errorMessage && !loadFailed && (
          <a
            target='_blank'
            href={imageLink}
            rel='nofollow noopener noreferrer'
          >
            <span>Online</span>
            <img
              className='popover-image_qc'
              alt=''
              src={onlineSrc}
              onError={handleImageError}
              style={{ border: border ? '1px solid beige' : '' }}
            />
          </a>
        )}

        {!isLoading && (errorMessage || loadFailed) && (
          <div
            className='popover-image_qc'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {errorMessage || 'Image unavailable'}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageAwarePopover;
